/* gd-cart-drawer
   ─────────────────────────────────────────────
   カート追加時に開くドロワー。
   - 中身の更新は Section Rendering API でセクションごと差し替える
     （金額・割引・在庫上限の計算を JS 側で二重実装しない）
   - ヘッダーのカートアイコンからも開く（JS無効時は /cart へ遷移）
   - Esc / オーバーレイで閉じる、フォーカストラップあり
   公開API: window.gdCartDrawer.open() / .close() / .refresh()
*/
(function () {
  'use strict';

  var SECTION_ID = 'gd-cart-drawer';
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocus = null;

  function el() { return document.getElementById('gd-cart-drawer'); }
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function updateHeaderCount(count) {
    var c = document.getElementById('gd-cart-count');
    if (!c) return;
    c.textContent = count;
    c.classList.toggle('gd-cart-count-empty', count === 0);
  }

  function open() {
    var d = el();
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.documentElement.classList.add('gd-no-scroll');
    var close = d.querySelector('.gd-cd-close');
    if (close) close.focus();
  }

  function close() {
    var d = el();
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('gd-no-scroll');
    var done = function () { d.hidden = true; };
    if (REDUCE) done(); else setTimeout(done, 240);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  /* セクションを取り直して中身を差し替える */
  function refresh() {
    var d = el();
    if (!d) return Promise.resolve();
    d.classList.add('is-busy');

    return fetch(rootUrl() + '?section_id=' + SECTION_ID, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('gd-cart-drawer');
        var current = el();
        if (!fresh || !current) return;

        var wasOpen = current.classList.contains('is-open');
        var wasHidden = current.hidden;

        current.innerHTML = fresh.innerHTML;
        current.dataset.itemCount = fresh.dataset.itemCount;
        current.hidden = wasHidden;
        current.classList.toggle('is-open', wasOpen);

        updateHeaderCount(parseInt(fresh.dataset.itemCount, 10) || 0);
      })
      .catch(function () {})
      .finally(function () {
        var c = el();
        if (c) c.classList.remove('is-busy');
      });
  }

  function change(line, quantity) {
    var d = el();
    if (d) d.classList.add('is-busy');
    return fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .catch(function () {
        var c = el();
        if (c) c.classList.remove('is-busy');
      });
  }

  /* イベントは document に委譲。差し替え後も再バインド不要にする */
  document.addEventListener('click', function (e) {
    var d = el();

    var openBtn = e.target.closest('[data-gd-cart-open]');
    if (openBtn && d) {
      e.preventDefault();
      refresh().then(open);
      return;
    }

    if (!d || d.hidden) return;

    if (e.target.closest('[data-gd-cd-close]')) { e.preventDefault(); close(); return; }

    var qtyBtn = e.target.closest('[data-gd-cd-qty]');
    if (qtyBtn) {
      var row = qtyBtn.closest('.gd-cd-item');
      var current = parseInt(row.querySelector('.gd-cd-qty span').textContent, 10) || 0;
      var next = current + parseInt(qtyBtn.dataset.gdCdQty, 10);
      var max = parseInt(qtyBtn.dataset.max, 10) || 0;
      if (next < 0) next = 0;
      if (max > 0 && next > max) return;
      change(parseInt(qtyBtn.dataset.line, 10), next);
      return;
    }

    var removeBtn = e.target.closest('[data-gd-cd-remove]');
    if (removeBtn) {
      change(parseInt(removeBtn.dataset.line, 10), 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = el();
    if (!d || d.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;

    var panel = d.querySelector('.gd-cd-panel');
    if (!panel) return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* 商品ページからの通知 */
  document.addEventListener('gd:cart:added', function () {
    refresh().then(open);
  });

  window.gdCartDrawer = { open: open, close: close, refresh: refresh };
})();
